import React, { useState } from "react";
import UtilitiesPhoto1 from "../../images/services/utilities.jpg";
import UtilitiesPhoto2 from "../../images/services/DJI_0001.jpg";
import UtilitiesPhoto3 from "../../images/services/DSC_0704.jpg";
import { FaMapMarkedAlt, FaClock } from "react-icons/fa";
import "./ServiceDetailStyles.css";

function UndergroundUtilities() {
  const slides = [UtilitiesPhoto1, UtilitiesPhoto2, UtilitiesPhoto3];
  const [current, setCurrent] = useState(0);

  const nextSlide = () => setCurrent((prev) => (prev + 1) % slides.length);
  const prevSlide = () =>
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);

  return (
    <>
      <div className="ttm-page-title ttm-bg clearfix">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="ttm-page-title-row-inner">
                <div className="page-title-heading">
                  <h2 className="title">Underground Utilities</h2>
                </div>
                <div className="breadcrumb-wrapper">
                  <span>
                    <a title="Services" href="/services">
                      <i className="fa fa-house" /> &nbsp; Services
                    </a>
                  </span>
                  <span>Underground Utilities</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* MAIN */}
      <section className="brw-service-detail brw-service-detail--utilities">
        <div className="container">
          <div className="row brw-service-detail__layout">
            {/* SIDEBAR */}
            <div className="col-lg-4">
              <div className="brw-service-detail__sidebar">
                <h4>Our Services</h4>
                <ul className="brw-service-detail__service-list">
                  <li className="active">
                    <a href="/undergroundUtilities">Underground Utilities</a>
                  </li>
                  <li>
                    <a href="/earthwork">Earthwork</a>
                  </li>
                  <li>
                    <a href="/pavingStriping">Paving & Striping</a>
                  </li>
                  <li>
                    <a href="/roadwayConstruction">Roadway Construction</a>
                  </li>
                  <li>
                    <a href="/segmentedRetainingWalls">
                      Segmented Retaining Walls
                    </a>
                  </li>
                  <li>
                    <a href="/concrete">Concrete</a>
                  </li>
                </ul>

                <div className="brw-service-detail__info-card">
                  <FaMapMarkedAlt />
                  <h5>Service Area</h5>
                  <p>
                    Central Florida & Surrounding Areas
                  </p>
                </div>

                <div className="brw-service-detail__info-card">
                  <FaClock />
                  <h5>Office Hours</h5>
                  <p>
                    Mon–Fri: 8:00 AM – 5:00 PM
                  </p>
                </div>
              </div>
            </div>

            {/* CONTENT */}
            <div className="col-lg-8">
              <div className="brw-service-detail__showcase">
                {/* SLIDER */}
                <div className="brw-service-detail__media">
                  <button
                    className="brw-service-detail__arrow brw-service-detail__arrow--prev"
                    onClick={prevSlide}
                    aria-label="Previous Slide"
                  >
                    ‹
                  </button>
                  <img
                    src={slides[current]}
                    alt="Underground Utilities Slide"
                    className="brw-service-detail__image"
                  />
                  <button
                    className="brw-service-detail__arrow brw-service-detail__arrow--next"
                    onClick={nextSlide}
                    aria-label="Next Slide"
                  >
                    ›
                  </button>
                </div>

                <h4>Expert Underground Utility Services For Your Project</h4>
                <p>
                  Our experienced crews handle installation, maintenance, and
                  repair of sanitary sewers, water mains, stormwater systems,
                  and more. BRW Contracting ensures projects are completed
                  efficiently, safely, and with minimal disruption to residents
                  and local occupants.
                </p>
                <p>
                  We prioritize safety, precision, and reliability on every job,
                  delivering long-lasting infrastructure solutions.
                </p>
                <div className="brw-service-detail__chips">
                  <span>Sanitary sewer</span>
                  <span>Water mains</span>
                  <span>Stormwater systems</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default UndergroundUtilities;
